var ComparisonJS = (function ($) {

    var slider = null;

    function init() {
        initCompareSERP('tyre');
        initComparePDP('tyre');
        initComparePage();

         if (IsMobile.any() && $('.compare-column').length > 1) {
             initSlider();
         }

         window.THEME.$document.on('updateContainerGroupsEqualHeightByMax', function() {
             ComparisonJS.setContainerGroupsEqualHeightByMax([
                 $('.sticky-bar-compare-wrapper .sticky-bar-comparison-product__top')
             ]);
         });
    }

    function initCompareSERP(productType) {
        // skip executing if page not serp
        if ($('.serp_gal').length == 0) {
            return;
        }

        // fetch product ids from LS
        let savedProductsInLS = getProductsFromLSByType(productType);

         // select checkbox which exist in LS
         $(':checkbox[name="compare"]').each(function() {
            const $compareCheckbox = $(this);
            const id = $compareCheckbox.attr('id').replace('product-checkbox-', '');
            savedProductsInLS.forEach(function(item) {
                if (item == id) {
                    $compareCheckbox.prop('checked', true);
                }
            });
        });

        // fetch products details from hybo and insert data into loaded page
        if (savedProductsInLS.length > 0) {
            $.ajax({
                method: "GET",
                url: "/add-to-compare",
                data: {productIDs: savedProductsInLS.join(), productType: productType}
            }).done(function (comparisonProductsHtml) {
                $("#comparisonProducts").html(comparisonProductsHtml);
                var compareButton = $("#compareButton");
                compareButton.css("visibility", "visible");
                var compareButtonWithCounter = $("#compareButtonWithCounter");
                var compareButtonWithCounterModal = $("#compareButtonWithCounterModal");
                compareButtonWithCounter.css("visibility", "visible");
                compareButtonWithCounterModal.css("visibility", "visible");
                productsLength = $(".compare-product-placed").length;
                if (productsLength > 1) {
                    compareButton.prop("disabled", false);
                    compareButtonWithCounter.prop("disabled", false);
                    compareButtonWithCounterModal.prop("disabled", false);
                    $(".compare-button-container").removeClass("compare-button-container-one-product");
                    $(".compare-button-container__show-btn").removeClass("compare-button-one-product");
                }
                $("#comparisonContainer > .compare-wrapper").css("visibility", "visible");
                handleComparisonDisplay();
                bindClickToRemoveOnSERP();
                bindClickToHideStickyBar();
                setUpToComparePageButton();
            });
        }

        $(".search-list-row .compareProduct, .row.serp .compareProduct").on('change', function () {
            var productsLength = $(".compare-product-placed").length;
            var $this = $(this);
            var productCode = $this.closest(".search-list-row, .row.serp").find("input[name='code']").val();
            var productType = $this.closest(".search-list-row, .row.serp").find("input[name='productType']").val();

            if ($this.is(':checked')) {
                if (productsLength === 3) {
                    showSerpConfirmComparePopUp(productCode, productType, $this);
                } else {
                    addComparisonTab(productCode, productType);
                }
            } else {
                removeComparisonTab(productCode, productType);
            }
        });
    }

    function initComparePDP(productType) {
        // skip executing if page not PDP
        if ($('.price-details-container').length == 0) {
            return;
        }

        // fetch product ids from LS
        let savedProductsInLS = getProductsFromLSByType(productType);
        // fetch products details from hybo and insert data into loaded page
        if (savedProductsInLS.length > 0) {
            $.ajax({
                method: "GET",
                url: "/add-to-compare",
                data: {productIDs: savedProductsInLS.join(), productType: productType, isFromPdp: true}
            }).done(function (comparisonProductsHtml) {
                let $htmlString = $(comparisonProductsHtml);
                $('.stickyBarComparisonProducts').html($htmlString[0]);
                if ($('.sticky-bar-compare-item').length > 0) {
                    $('.stickyBarComparisonProducts').removeClass('hidden');
                } else {
                    $('.stickyBarComparisonProducts').addClass('hidden');
                }
                bindClickToRemoveFromStickBarOnPdp();
                bindClickToHideStickyBar();
                setUpToComparePageButton(true);
                // checked comparison checkBox if product has been already added to comparison list
                const productCode = $(':input[name="code"]').val();
                savedProductsInLS.forEach(function (item) {
                    if (productCode == item) {
                        $(".pdpCompareProduct").prop('checked', true);
                    }
                });

                if ($('#pdpCompareButton').length > 0 && $('.pdpCompareProduct').is(':checked')) {
                    enableComparisonProductsButton();
                }

                $(".pdpCompareProduct").on('change', function () {
                    changeCompareProductPDP();
                });

            });
        }
    }

    function changeCompareProductPDP($this, fromStickyBar) {
        var compareButtonForm = $("#compareButtonForm");
        var productCode = ($this && $this.length > 0)
            ? $this.closest(".compare-product-container").find(".compareProductCode").val()
            : compareButtonForm.find("input[name='productCode']").val();
        var productType = compareButtonForm.find("input[name='productType']").val();

        var compareCheckbox = $('#product-checkbox-' + productCode);
        if (fromStickyBar) {
            compareCheckbox.prop('checked', !compareCheckbox.is(':checked'));
        }

        if (compareCheckbox.is(':checked')) {
            const nrOfProducts = getProductsFromLSByType('tyre').length;
            if (nrOfProducts >= 3) {
                showPdpConfirmComparePopUp(productCode, productType);
            } else {
                addComparisonProductFromPdp(productCode, productType);
            }
        } else {
            removeComparisonProductFromPdp(productCode, productType)
        }
    }

    //showing window with information if user have more then 3 products in comparing area in serp
    var showSerpConfirmComparePopUp = function ($productCode, $productType, $this) {

        var firstCompareProductBrandName = $("#comparisonContainer .compare-column").first().find("input[name='productBrandName']").val();
        var firstCompareProductName = $("#comparisonContainer .compare-column").first().find("input[name='productName']").val();

        var firstCompareProductFullName = firstCompareProductBrandName + " " + firstCompareProductName;

        var $message = ACC.compareProductConfirmation.replace("{0}", firstCompareProductFullName);
        var $yes = ACC.compareProductConfirmationYes;
        var $no = ACC.compareProductConfirmationNo;

        setTimeout(function () {
            var $wrapperDiv = new BackgroundBox('wrapperBackground', $message);

            var $childDiv = $($wrapperDiv.domElement.lastChild);

            $($childDiv).append('<div style="margin-top: 15px;">' +
                '<a class="wrapperBackground__button-yes">' + $yes + '</a>' +
                '<a class="wrapperBackground__button-no">' + $no + '</a>' +
                '</div>');

            var $cssObj = {
                'display': 'inline-block',
                'padding': '10px',
                'font-size': '14px',
                'border': '1px solid #dadada',
                'box-shadow': '2px 2px 2px #dadada',
                'border-radius': '4px',
                'margin': '5px 10px',
                'text-decoration': 'none'
            };

            var $wrapperBackground__buttonNo = $('.wrapperBackground__button-no');
            var $wrapperBackground__buttonYes = $('.wrapperBackground__button-yes');
            $wrapperBackground__buttonNo.css($cssObj);
            $wrapperBackground__buttonYes.css($cssObj);

            $wrapperBackground__buttonYes.on('click', function () {
                var firstCompareProductCode = $("#comparisonContainer .compare-column").first().find(".compareProductCode").val();
                var firstCompareProductType = $("#comparisonContainer .compare-column").first().find("input[name='productType']").val();
                removeComparisonTab(firstCompareProductCode, firstCompareProductType, $productCode, $productType, addComparisonTab);
                $wrapperDiv.hideWithDelay(100);
            });

            $wrapperBackground__buttonNo.on('click', function () {
                $this.prop("checked", false);
                $wrapperDiv.hideWithDelay(100);
            });

            $wrapperDiv.show();

        }, 300);
    };

    //showing window with information if user have more then 3 products in comparing area in pdp
    var showPdpConfirmComparePopUp = function ($productCode, $productType) {

        var firstCompareProductCode = getProductsFromLSByType('tyre')[0];
        var $firstProductContainer = $('#sticky-bar-product-' + firstCompareProductCode);

        var firstCompareProductBrandName = $firstProductContainer.find("input[name='productBrandName']").val();
        var firstCompareProductName = $firstProductContainer.find("input[name='productName']").val();
        var firstCompareProductFullName = firstCompareProductBrandName + " " + firstCompareProductName;
        var firstCompareProductType = $firstProductContainer.find("input[name='productType']").val();

        var $message = ACC.compareProductConfirmation.replace("{0}", firstCompareProductFullName);
        var $yes = ACC.compareProductConfirmationYes;
        var $no = ACC.compareProductConfirmationNo;

        setTimeout(function () {
            var $wrapperDiv = new BackgroundBox('wrapperBackground', $message);

            var $childDiv = $($wrapperDiv.domElement.lastChild);

            $($childDiv).append('<div style="margin-top: 15px;">' +
                '<a class="wrapperBackground__button-yes">' + $yes + '</a>' +
                '<a class="wrapperBackground__button-no">' + $no + '</a>' +
                '</div>');

            var $cssObj = {
                'display': 'inline-block',
                'padding': '10px',
                'font-size': '14px',
                'border': '1px solid #dadada',
                'box-shadow': '2px 2px 2px #dadada',
                'border-radius': '4px',
                'margin': '5px 10px',
                'text-decoration': 'none'
            };

            var $wrapperBackground__buttonNo = $('.wrapperBackground__button-no');
            var $wrapperBackground__buttonYes = $('.wrapperBackground__button-yes');
            $wrapperBackground__buttonNo.css($cssObj);
            $wrapperBackground__buttonYes.css($cssObj);

            $wrapperBackground__buttonYes.on('click', function () {
                removeComparisonProductFromPdp(firstCompareProductCode, firstCompareProductType, $productCode, $productType, addComparisonProductFromPdp);
                $wrapperDiv.hideWithDelay(100);
            });

            $wrapperBackground__buttonNo.on('click', function () {
                $(".pdpCompareProduct").prop("checked", false);
                $("#pdpCompareButton").prop("disabled", false);
                $wrapperDiv.hideWithDelay(100);
            });

            $wrapperDiv.show();

        }, 300);
    };

    function initComparePage() {
        $(".comparison-product-back-link").on('click', function () {
            if (window.document.referrer) {
                window.location.href = window.document.referrer;
            }
        });
        $(".comparison-remove-details-page").on('click', function () {
            var productCode = $(this).closest(".comparison-top-actions").find(".compareProductCode").val();
            var productType = $(this).closest(".comparison-top-actions").find(".compareProductType").val();
            var button = $(this);
            var cellIndex = button.closest("td").index();
            $(".table tr").each(function () {
                var cells = $(this).children();

                cells.each(function () {
                    if ($(this).index() === cellIndex) {
                        $(this).remove();
                        return false;
                    }
                });
            });
            showMessageIfEmptyList();
            hideEmptyRows();
            removeProductFromLS(productCode, productType);
            let currentURL = window.location.href;
            let updatedURL = currentURL.replace('&ids=' + productCode, '');
            window.location.href = updatedURL;
        });
        showMessageIfEmptyList();
        setContainerGroupsEqualHeightByMax([$('.comparison-product-details'), $('.comparison-product-description')]);
        hideEmptyRows();
    }

    function hideEmptyRows() {

        $(".table tr").each(function () {
            var count = 0;

            var cells = $(this).find(".comparison-product-detail");
            cells.each(function () {
                var cellValue = $(this).text().replace(/\s+/g, '');
                if (cellValue !== "-" && cellValue !== "") {
                    count++;
                }
            });
            if (count === 1) {
                $(this).hide();
            }
        });
    }

    function showMessageIfEmptyList() {
        if ($(".comparison-product-informations-details-page").length === 0) {
            $(".comparisonProdPageEmpty").css("display", "block");
            $(".table-responsive.comparisonDetails table.table").css("display", "none");
        }
    }

    function bindClickToRemoveOnSERP() {
        $("#comparisonProducts .comparison-remove").on('click', function () {
            var productCode = $(this).closest(".compare-product-container").find(".compareProductCode").val();
            var productType = $(this).closest(".compare-product-container").find("input[name='productType']").val();
            removeComparisonTab(productCode, productType);
        });
    }

    function bindClickToRemoveFromStickBarOnPdp() {
        $('.sticky-bar-comparison-top-actions > .comparison-remove').on('click', function() {
            const $inputsContainer = $(this).closest('.sticky-bar-comparison-product-information');
            const productType = $inputsContainer.find(':input[name="productType"]').val();
            const productCode = $inputsContainer.find(':input.compareProductCode').val();
            removeComparisonTab(productCode, productType);
        });
    }

    function bindClickToHideStickyBar() {
        $("#stickyBarCloseButtonWithCounter").on('click', function () {
            $('.stickyBarComparisonProducts').addClass("hidden");
            $('#stickyBarShowContainerButton').removeClass("hidden");
        });

        $("#stickyBarShowContainerButton").on('click', function () {
            $('.stickyBarComparisonProducts').removeClass("hidden");
            $('#stickyBarShowContainerButton').addClass("hidden");
            window.THEME.$document.trigger("updateContainerGroupsEqualHeightByMax");
        });

    }

    function enableComparisonProductsButton() {
        var productType = $("#compareButtonForm").find("input[name='productType']").val();
        const nrOfProducts = getProductsFromLSByType(productType).length;
        if (nrOfProducts >= 2) {
            $("#pdpCompareButton").prop("disabled", false);
        }
    }

    function handleComparisonDisplay() {
        var compareProductLength = $(".compare-product-placed").length;
        var compareButton = $("#compareButton");
        var compareButtonWithCounter = $("#compareButtonWithCounter");
        if (compareProductLength === 0) {
            $("#comparisonProducts").css("display", "none");
            $('.stickyBarComparisonProducts').addClass("hidden");
        }
        if (compareProductLength <= 3 && compareProductLength !== 0) {
            $("#comparisonProducts").css("display", "block");
            $('.stickyBarComparisonProducts').removeClass("hidden");
            compareButton.css("visibility", "visible");
            compareButtonWithCounter.css("visibility", "visible");
            $(".compare-button-container__show-btn").css("display", "block");
            $(".counter").html(compareProductLength);
            $(".compare-button-container__show-btn span").html(compareProductLength);
            $(".productListComponent > .search-list-info").addClass("comparison-open");
            if (compareProductLength > 1) {
                compareButton.prop("disabled", false);
                compareButtonWithCounter.prop("disabled", false);
                $(".compare-button-container").removeClass("compare-button-container-one-product");
                $(".compare-button-container__show-btn").removeClass("compare-button-one-product");
            }

            placeAddToCompareText(compareProductLength);
            $(".compare-wrapper").css("visibility", "visible");
            setContainerGroupsEqualHeightByMax([$('.comparison-product-details'), $('.comparison-product-description')]);
        }

        var $compareButtonContainerShowBtn = $('.compare-button-container__show-btn');
        if ($compareButtonContainerShowBtn.length) {
            $compareButtonContainerShowBtn.on('click', function () {
                $(this).toggleClass('active');
                $('.compare-button-container').toggleClass('active');
            });
        }

    }

    function placeAddToCompareText(numOfProducts) {
        for (var i = numOfProducts; i < 3; i++) {
            $("#comparisonContainer > .compare-wrapper").append("<div" +
                " class=\"compare-column\">"
                + "<p class=\"add-product-to-compare\">" + $("#add-to-compare").text() + "</p>"
                + "</div>"
            )
        }
    }

    function addComparisonTab(productCode, productType) {

        var comparisonProducts = $("#comparisonProducts");
        comparisonProducts.empty();

        let products = getAndAddProductsFromLSByType(productType, productCode);

        $.ajax({
            method: "GET",
            url: "/add-to-compare",
            data: {productIDs: products[productType].join(), productType: productType}
        }).done(function (comparisonProductsHtml) {
            $("#comparisonProducts").html(comparisonProductsHtml);
            var compareButton = $("#compareButton");
            compareButton.css("visibility", "visible");
            var compareButtonWithCounter = $("#compareButtonWithCounter");
            var compareButtonWithCounterModal = $("#compareButtonWithCounterModal");
            compareButtonWithCounter.css("visibility", "visible");
            compareButtonWithCounterModal.css("visibility", "visible");
            productsLength = $(".compare-product-placed").length;
            if (productsLength > 1) {
                compareButton.prop("disabled", false);
                compareButtonWithCounter.prop("disabled", false);
                compareButtonWithCounterModal.prop("disabled", false);
                $(".compare-button-container").removeClass("compare-button-container-one-product");
                $(".compare-button-container__show-btn").removeClass("compare-button-one-product");
            }
            $("#comparisonContainer > .compare-wrapper").css("visibility", "visible");
            bindClickToRemoveOnSERP();
            bindClickToHideStickyBar();
            handleComparisonDisplay();
            setUpToComparePageButton();

            if (IsMobile.any() && $('.compare-column').length > 1) {
                initSlider();
            }
            window.THEME.$document.trigger("addRedirectPDPLinkToClientReviewSection");
            window.THEME.$document.trigger("updateContainerGroupsEqualHeightByMax");
            window.THEME.initTooltips();
            $('#addToComparisonModal').modal('show');
        });

    }

    function removeComparisonTab(productCode, productType, $productCode, $productType, callback) {
        removeProductFromLS(productCode, productType);
        $("#product-checkbox-" + productCode).prop("checked", false);
        $("#product-" + productCode).closest(".compare-column").remove();
        removeProductFromStickyBar(productCode);
        var compareButtonWithCounter = $("#compareButtonWithCounter");
        var productsLength = $(".compare-product-placed").length;
        $(".counter").html(productsLength);
        $(".compare-button-container__show-btn span").html(productsLength);
        var sliderSelector = $('.comparisonProducts .bx-wrapper');
        if (productsLength === 0) {
            if (sliderSelector.length) {
                $("#comparisonContainer > .bx-wrapper > .bx-viewport > .compare-wrapper").empty();
            } else {
                $("#comparisonContainer > .compare-wrapper").empty();
            }
            $("#compareButton").css("visibility", "hidden");
            compareButtonWithCounter.css("visibility", "hidden");
            $("#comparisonProducts").css("display", "none");
            $(".productListComponent > .search-list-info").removeClass("comparison-open");
        } else {
            if (productsLength === 1) {
                $("#compareButton").attr("disabled", "true");
                compareButtonWithCounter.attr("disabled", "true");
                $(".compare-button-container").addClass("compare-button-container-one-product");
                $(".compare-button-container__show-btn").addClass("compare-button-one-product");
            }

            var emptySlide = "<div class=\"compare-column\">" +
                "<p class=\"add-product-to-compare\">" + $("#add-to-compare").text() + "</p>" +
                "</div>";
            if (sliderSelector.length) {
                if (slider) {
                    var currentSlide = slider.getCurrentSlide();
                    slider.reloadSlider(getCarouselConfig(currentSlide));
                }
            } else {
                $("#comparisonContainer > .compare-wrapper").append(emptySlide);
            }
        }
        if (callback) {
            callback($productCode, $productType)
        }
    }

    function removeProductFromStickyBar(productCode) {
        var $stickyBarProduct = $("#sticky-bar-product-" + productCode);
        if ($stickyBarProduct.length > 0) {
            $stickyBarProduct.closest(".sticky-bar-compare-column").remove();
            var emptySlide = "<div class=\"sticky-bar-compare-column sticky-bar-empty-slot\">" +
                "<p class=\"add-product-to-compare-text\">" + $("#add-to-compare").text() + "</p>" +
                "</div>";
            $("#stickyBarComparisonContainer .sticky-bar-compare-buttons-container").before(emptySlide);

            if ($('.sticky-bar-compare-column.sticky-bar-compare-item').length < 1) {
                $('.stickyBarComparisonProducts').addClass("hidden");
                $('#stickyBarShowContainerButton').addClass("hidden");
            }

            changeStickyBarCounter(false);
            window.THEME.$document.trigger("updateContainerGroupsEqualHeightByMax");
        }
    }

    function addComparisonProductFromPdp($productCode, $productType) {
        let products = getAndAddProductsFromLSByType($productType, $productCode);

        const nrOfProducts = products[$productType].length;
        if (nrOfProducts >= 2) {
            $("#pdpCompareButton").prop("disabled", false);
        }

        var $stickyBarProduct = $("#sticky-bar-template-" + $productCode).clone();
        $stickyBarProduct[0].id = "sticky-bar-product-" + $productCode;
        $stickyBarProduct.removeClass("sticky-bar-compare-template").addClass("sticky-bar-compare-item");
        $($(".sticky-bar-compare-column.sticky-bar-empty-slot")[0]).before($stickyBarProduct);
        $($(".sticky-bar-compare-column.sticky-bar-empty-slot")[0]).remove();
        var $stickyBarComparisonProducts = $('.stickyBarComparisonProducts');
        if ($stickyBarComparisonProducts.length > 0 && $stickyBarComparisonProducts.hasClass("hidden")) {
            $stickyBarComparisonProducts.removeClass("hidden");
        }
        $('#stickyBarShowContainerButton').addClass("hidden");

        changeStickyBarCounter(true);
        window.THEME.$document.trigger("updateContainerGroupsEqualHeightByMax");
    }

    function changeStickyBarCounter(value) {
        var $stickyBarCounter = $('#stickyBarCounter')[0];
        if ($stickyBarCounter) {
            var count = parseInt($stickyBarCounter.textContent);
            $stickyBarCounter.innerText = (value ? ++count : --count);
        }
    }

    function removeComparisonProductFromPdp(productCode, productType, $productCode, $productType, callback) {
            const nrOfProducts = removeProductFromLS(productCode, productType);
            if (nrOfProducts < 2) {
                $("#pdpCompareButton").attr('disabled', 'disabled');
            }
            removeProductFromStickyBar(productCode);

            if (callback) {
                callback($productCode, $productType)
            }
    }

    function getCarouselConfig(startSlide) {
        return {
            startSlide: startSlide,
            mode: 'horizontal',
            slideWidth: '400',
            touchEnabled: false,
            infiniteLoop: false,
            pager: false,
            prevText: '<i class="fa fa-chevron-left fa-2x"></i>',
            nextText: '<i class="fa fa-chevron-right fa-2x"></i>'
        }
    }

    function setContainerGroupsEqualHeightByMax(containerGroups) {
        containerGroups.forEach(function (containerGroup) {
            setContainersEqualHeightByMax(containerGroup);
        });
    }

    function setContainersEqualHeightByMax(containers) {
        if (containers.length > 0) {
            containers.map(function () {
                $(this).css("height", 'auto');
            });
            var heights = containers.map(function () {
                return $(this).outerHeight();
            }).get();
            var maxHeight = Math.max.apply(null, heights);
            containers.map(function () {
                $(this).css("height", maxHeight);
            })
        }
    }

    function initSlider() {
        var selector = $('.compare-wrapper');
        var isSliderHide = $(window).width() > 767;

        if (selector.length && !isSliderHide) {
            slider = selector.bxSlider(getCarouselConfig());
        }

        $(window).on('resize', function () {
            handleReproductionSlider(slider);
        });

        handleReproductionSlider(slider);
    }

    function handleReproductionSlider(courusel) {
        var isReceiveSlider = $(window).width() < 768 && $('.compare-wrapper').length;
        var sliderSelector = $('.comparisonProducts .bx-wrapper');
        var isSliderHide = $(window).width() > 767 && sliderSelector.length;
        var needToLoadSlider = $(window).width() < 768 && !sliderSelector.length;

        if (needToLoadSlider) {
            initSlider();
            return;
        }

        //for devices < 768
        if (isReceiveSlider && courusel) {
            courusel.reloadSlider();
        }

        //for devices > 767
        if (isSliderHide && courusel) {
            courusel.destroySlider();
        }
    }

    function getProductsFromLSByType(productType) {
        let products = JSON.parse(localStorage.getItem('comparison:products'));
        let productsByType = [];
        if (products != null && typeof products[productType] != 'undefined') {
            productsByType = products[productType];
        }
        return productsByType;
    }

    function getAndAddProductsFromLSByType(productType, productCode) {
        let products = JSON.parse(localStorage.getItem('comparison:products'));
        if (products == null) {
            products = {};
            products[productType] = [productCode];
            localStorage.setItem('comparison:products', JSON.stringify(products));
        } else {
            if (typeof products[productType] == 'undefined') {
                products[productType] = [];
            }
            products[productType].push(productCode);
            localStorage.setItem('comparison:products', JSON.stringify(products));
        }
        return products;
    }

    function removeProductFromLS(productCode, productType) {
        let products = JSON.parse(localStorage.getItem('comparison:products'));
        if (products == null) {
            return -1;
        } else {
            if (typeof products[productType] == 'undefined') {
                return -1;
            } else {
                let updatedProducts = [];
                products[productType].forEach(id => {
                    if (id != productCode) {
                        updatedProducts.push(id);
                    }
                });
                products[productType] = updatedProducts;
                localStorage.setItem('comparison:products', JSON.stringify(products));
                return updatedProducts.length;
            }
        }
    }

    function setUpToComparePageButton(isFromPdp) {
        $('#stickyBarCompareButtonWithCounter, #compareButtonWithCounter, #compareButton, #compareButtonWithCounterModal, #pdpCompareButton').on('click', function() {
            const $this = $(this);
            const $form = isFromPdp
                ? $this.closest('.price-details-container').find('#compareButtonForm')
                : $this.parents('form:first');
            getProductsFromLSByType('tyre').forEach(function(item) {
                $('<input type="hidden" />')
                    .attr('name', 'ids')
                    .attr('value', item)
                    .appendTo($form);
            });
            $form.submit();
        });
    }

    return {
        init: init,
        setContainerGroupsEqualHeightByMax: setContainerGroupsEqualHeightByMax,
        placeAddToCompareText: placeAddToCompareText,
        removeComparisonTab: removeComparisonTab
    }

})($);

$(document).ready(function () {
    if ($('#comparisonProducts').length || $('.comparisonProductsDetailsPage').length ||
        $('.pdpCompareProduct').length) {
        ComparisonJS.init();

        if ($('.sticky-bar-compare-column.sticky-bar-compare-item').length > 0 && $('.stickyBarComparisonProducts').hasClass("hidden")) {
            $('.stickyBarComparisonProducts').removeClass("hidden");
        }

        ComparisonJS.setContainerGroupsEqualHeightByMax([
            $('.comparison-product-details'),
            $('.comparison-product-description'),
            $('.comparison-product-informations-details-page'),
            $('.comparison-product-details-table'),
            $('.sticky-bar-compare-wrapper .sticky-bar-comparison-product__top')
        ]);

        if (IsMobile.any()) {
            $(window).resize(function () {
                ComparisonJS.setContainerGroupsEqualHeightByMax([
                    $('.comparison-product-details'),
                    $('.comparison-product-description'),
                    $('.comparison-product-informations-details-page'),
                    $('.comparison-product-details-table'),
                    $('.sticky-bar-compare-wrapper .sticky-bar-comparison-product__top')
                ]);
            });
        }
    }
    $('[data-toggle="tooltip"]').tooltip();
    if (IsMobile.any()) {
        $(".tooltip-for-filters").on('mouseover', function () {
            $("a.close_btn").css("display", "block");
        })
    }
});